<template>
  <div class="after-recharge">
    <nav-header module="充值"></nav-header>
    <div class="container">
      <i class="el-icon-success"></i>
      <div class="tip">提交成功!</div>
      <p class="desc">您的汇款资料已上传，请耐心等候速派后台确认<br>如有疑问，请联系客服电话021-60956592</p>
      <button class="btn-primary" @click="$router.push('/center/balance')">查看余额</button>
    </div>
  </div>
</template>
<script>
import navHeader from '@/components/navHeader.vue'
export default {
  components:{
    navHeader,
  },
  data(){
    return{
      
    }
  }
}
</script>
<style lang="scss">
.after-recharge{
  background-color: #f9f9f9;
  min-height: 100vh;
  overflow: hidden;
  .container{
    width: 1000px;
    margin: 0px auto;
    padding-top: 68px;
    overflow: hidden;
    text-align: center;
    .el-icon-success{
      font-size: 64px;
      color: green;
      margin-bottom: 10px;
      margin-top: 100px;
    }
    .tip{
      font-size: 30px;
      font-weight: bold;
      color: #666;
      line-height: 1.5;
    }
    .desc{
      font-size: 14px;
      line-height: 40px;
      margin-bottom: 10px;
      color: #999;
    }
    .btn-primary{
      width: 100px;
      height: 30px;
      border-radius: 2px;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
    }
  }
}
</style>